<template>
  <div class="payment-container">
    <v-layout row wrap>
      <v-flex lg5 md5 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <div class="card-header">
              <h1 class="earth-color">USER TYPE</h1>
              <div class="title-decoration"></div>
            </div>
            <v-container>
              <v-form @submit.prevent="postUserType()" ref="form" v-model="valid">
                <v-text-field
                  label="Name"
                  v-model="type.name"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                ></v-text-field>
                <v-textarea
                  label="Description"
                  v-model="type.description"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                  rows="3"
                ></v-textarea>
                <v-switch
                  color="#587e27"
                  label="Has Account"
                  v-model="type.has_account"
                  class="futuristic-input"
                ></v-switch>
                <v-btn 
                  depressed 
                  color="#587e27" 
                  block 
                  type="submit" 
                  class="futuristic-btn rounded-btn"
                  v-if="update === false"
                >
                  Add User Type
                </v-btn>
                <v-btn 
                  depressed 
                  color="#ff9800" 
                  block 
                  type="submit" 
                  class="futuristic-btn rounded-btn"
                  v-if="update === true"
                >
                  Update User Type
                </v-btn>
              </v-form>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg7 md7 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <div class="card-header">
              <h1 class="earth-color">USER TYPES</h1>
              <div class="title-decoration"></div>
            </div>
            <v-container class="table-container">
              <v-data-table
                :headers="headers"
                :items="allUserTypes"
                hide-actions
                class="futuristic-table"
                :loading="$loadingTrue"
              >
                <v-progress-linear
                  slot="progress"
                  color="#587e27"
                  indeterminate
                  height="3"
                ></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <td>{{ props.index + 1 }}</td>
                  <td class="font-weight-medium">{{ props.item.name }}</td>
                  <td>
                    <v-chip 
                      small 
                      :color="props.item.has_account ? '#44bd32' : '#9e9e9e'"
                      text-color="white"
                      class="status-chip rounded-chip"
                    >
                      {{ props.item.has_account ? 'Yes' : 'No' }}
                    </v-chip>
                  </td>
                  <td>
                    <div class="action-buttons">
                      <v-btn 
                        depressed 
                        color="#ff9800" 
                        small 
                        @click="updateType(props.item)"
                        class="futuristic-btn rounded-btn action-btn"
                        v-if="!update"
                      >
                        Amend
                      </v-btn>
                      <v-btn 
                        depressed 
                        color="#f44336" 
                        small 
                        @click="cancelAmendment()"
                        class="futuristic-btn rounded-btn action-btn"
                        v-if="update"
                      >
                        Cancel Amendment
                      </v-btn>
                      <v-btn 
                        depressed 
                        color="#2196f3" 
                        small 
                        @click="assignRoles(props.item.public_id)"
                        class="futuristic-btn rounded-btn action-btn"
                        v-if="!update"
                      >
                        Assign Features
                      </v-btn>
                      <v-btn 
                        depressed 
                        color="#f44336" 
                        small 
                        @click="deleteUserType(props.item.public_id)"
                        class="futuristic-btn rounded-btn action-btn"
                        v-if="!update"
                      >
                        Disable
                      </v-btn>
                    </div>
                  </td>
                </template>
                <template slot="no-data">
                  <div class="text-xs-center py-4">
                    No user types available
                  </div>
                </template>
              </v-data-table>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      update: false,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      headers: [
        { text: '#', value: '', sortable: false, class: 'table-header' },
        { text: 'Name', value: 'name', sortable: false, class: 'table-header' },
        { text: 'Has Account', value: 'has_account', sortable: false, class: 'table-header' },
        { text: 'Actions', value: '', sortable: false, class: 'table-header' }
      ],
      type: {
        name: '',
        description: '',
        has_account: false,
        public_id: ''
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_user_types')
    this.$store.dispatch('get_all_menus')
  },
  methods: {
    cancelAmendment: function () {
      this.update = false
      this.type.name = ''
      this.type.description = ''
      this.type.public_id = ''
      this.type.has_account = false
    },
    updateType: function (type) {
      this.update = true
      this.type.name = type.name
      this.type.description = type.description
      this.type.public_id = type.public_id
      this.type.has_account = type.has_account
    },
    getFeatures: function (publicId) {
      this.$router.push({
        name: 'Features',
        params: {
          menu_id: publicId
        }
      })
    },
    assignRoles: function (publicId) {
      this.$router.push({
        name: 'Roles',
        params: {
          role_id: publicId
        }
      })
    },
    deleteUserType: function (publicId) {
      if(confirm('Are you sure you want to disable this user type?')) {
        this.$store.dispatch('delete_user_type', publicId)
      }
    },
    postUserType: function () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('loading_true')
        if (this.update === false) {
          this.$store.dispatch('post_user_type', this.type)
        } else {
          this.$store.dispatch('update_user_type', this.type)
        }
      }
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  height: 100%;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.rounded-btn {
  border-radius: 24px !important;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.action-btn {
  min-width: auto;
  padding: 0 12px;
}

.rounded-chip {
  border-radius: 12px;
}

.status-chip {
  font-weight: 500;
}

.table-container {
  padding: 0;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }
  
  .card-header {
    padding: 12px;
  }
  
  .earth-color {
    font-size: 1.35rem;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }
  
  .card-header {
    padding: 8px;
  }
  
  .earth-color {
    font-size: 1.2rem;
  }
  
  .action-btn {
    font-size: 12px;
    padding: 0 8px;
  }
}
</style>